/** Serialize string arrays as comma-separated query values for Hapi/Zod. */
export function toCommaQueryParam(
  values: string[] | undefined
): string | undefined {
  if (values == null || values.length === 0) {
    return undefined
  }
  return values.join(',')
}
